import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { StorageService } from "..";
import { RouterStateSnapshot } from "@angular/router";
import * as settings from "src/app/shared/lib/api-constant";
import { AppRoutes } from "../../lib/api-constant";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, from, interval, Observable, Subject, throwError } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

import { MessageService } from "primeng/api";
import { BdpDialogTypes, DialogService } from '../../service/dialog/dialog.service';
import { CommonService } from "../common/common.service";
import moment from 'moment';
import { UtilityService } from "../utility/utility.service";
import { InactivityService } from "../inactivity/inactivity.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})

export class AuthService {

  public static lastApiCall: any = null;
  private schedule: any
  private user: UserDetails = null;
  private isSessionCheckActive: boolean = true;
  private userPromise = new BehaviorSubject<UserDetails>(this.user);
  public $user = this.userPromise.asObservable();
  private eluaPromise = new BehaviorSubject<any>(null);
  public $eula = this.eluaPromise.asObservable();
  private companyListPromise = new BehaviorSubject<any>(null);
  public $companyList = this.companyListPromise.asObservable();
  data: any = null;

  private pendingHTTPRequests$ = new Subject<void>();

  constructor(
    public router: Router,
    protected http: HttpClient,
    private commonService: CommonService,
    public storageService: StorageService,
    public messageService: MessageService,
    public auth: Auth0Service,
    private inactivityService: InactivityService,
    private dilogService: DialogService,
    // @Inject(DOCUMENT) private document: Document
  ) {
    // this.storageService.setItem("isEulaAccecpted", 1);
    // this.updateUser(this.storageService.getItem('user'));
  }

  //#region PUBLIC METHODS
  public get token() {
    return this.storageService.getItem("token");//Get the token from storage
  }

  public accessDeniedRedirect() {
    this.router.navigate([AppRoutes.AuthAbstract.ACCESS])
  }

  public reactivateRedirect() {
    // this.document.location.href = `${environment.smartHubUrl}${AppRoutes.AuthFull.REACTIVATE_ACCOUNT}`;
  }



  public setToken(token: string) {
    this.storageService.setItem("token", token);//Set the token while loggin for first time
  }

  public checkAuth() {
    return this.token ? true : false;
  }

  public login() {
    /** Auth0 */
    this.auth.loginWithRedirect().subscribe({
      next: (res: any) => {
        console.log(res);
      },
      error: (err) => {
        this.logout();
      }
    });
    return this.auth.idTokenClaims$;
  }

  /**
   * Redirect to Login after logout
   */
  public logoutRedirect() {
    console.log("logout");
    this.commonService.navigateRoute({
      route: AppRoutes.Auth.LOGIN,
    });
  }

  /**
   * Password confirmation for the user
   */
  public passwordResetConfirmNav() {
    this.commonService.navigateRoute({
      route: AppRoutes.Auth.PASSWORD_CONFIRM,
    });
  }

  /**
   * Resend link for the user
   */
  public passwordResendNav() {
    this.commonService.navigateRoute({
      route: AppRoutes.Auth.RESEND_LINK,
    });
  }
  //#endregion

  // //#region PUBLIC METHODS FOR API CALL FOR AUTHENTICATION
  // //Logout method removing the email, passowrd, token, keepsignin and state
  // public logout() {
  //   clearInterval(this.schedule);
  //   const rememberEmail = this.storageService.getItem('rememberEmail');
  //   let email = this.storageService.getItem('email');
  //   const recentShipment = this.storageService.getItem('recentShipment-' + email);
  //   const redirectUrl = this.storageService.getItem('redirectUrl');
  //   localStorage.clear();
  //   // sessionStorage.clear();
  //   //Do not clear below fields rememberEmail,email,recentShipment we need it after login. 
  //   this.storageService.setItem('rememberEmail', rememberEmail);
  //   this.storageService.setItem('email', email);
  //  // this.auth.logout({ returnTo: document.location.origin });
  //  this.auth.logout();
  //   // this.logoutRedirect();
  // }

  public refreshSession() {
    let refreshToken = null;
  }



  public register(body: any) {
    return this.http.post(
      settings.AdminEndPoint.UserManagement.REGISTER_USER,
      body
    );
  }

  public getUserstype() {
    return this.http.get(
      settings.AdminEndPoint.UserManagement.USERS
    );
  }

  public forceChangePassowrdRedirect() {
    let params = {
      returnTo: window.location.origin
    };
    let token = UtilityService.convertToBase64(JSON.stringify(params));
    window.open(`${environment.ump_endpoint_url}${AppRoutes.UserFull.COMMON_CHANGE_PASSWORD}/?token=${token}`, '_self')?.focus();
  }

  public profileRedirect() {
    let params = {
      returnTo: window.location.origin
    };
    let token = UtilityService.convertToBase64(JSON.stringify(params));
    window.open(`${environment.ump_url + "/#"}${AppRoutes.UserFull.PROFILE}/?token=${token}`, '_self')?.focus();
  }

  public changePasswordRedirect() {
    let params = {
      returnTo: window.location.href
    };
    let token = UtilityService.convertToBase64(JSON.stringify(params));
    window.open(`${environment.ump_url + "/#"}${AppRoutes.UserFull.CHANGE_PASSWORD}/?token=${token}`, '_self')?.focus();
  }


  public getUser() {
    return this.user;
  }

  /**
   * This method contains triggers when the user is inactive for more than 2 mins
   * Triggers should be activated only when the user has logged in
   * One is idle trigger and the other is wake trigger
   * 
   * When Idle : The session check every 5 mins is disabled
   * When wake : When the user wakes the applicaiton after being idle then it
   *    should call the silent authenticaiton method to make sure the user stays loggedIn
   *    otherwise auth0 will log out the user after 15 mins of inactivity.
   */
  public checkInactivityStatus() {
    this.inactivityService.idle$.subscribe({
      next: (res) => {
        const duration = Math.floor(res.duration / (60 * 1000))
        if (res.isIdle) {
          console.log(`User has been idle for ${duration} minutes`)
          this.isSessionCheckActive = false;
        }
      }
    })
    this.inactivityService.wake$.subscribe({
      next: (res) => {
        if (res && res.isActive) {
          this.isSessionCheckActive = true;
          const duration = Math.floor(res.duration / (60 * 1000))
          if (duration && duration > 5) {
            this.silentAuthentication();
          }
        }
      }
    })
  }

  public silentAuthentication() {
    let options = { ignoreCache: true };
    this.auth.getAccessTokenSilently(options).subscribe({
      next: (res: any) => { this.storageService.setItem("token", res) },
      error: () => this.logout()
    });
  }

  /**
  * This method will check the authentication status at an interval to check
  * if the user is authenticated or not.
  */
  public checkAuthenticationStatus() {
    interval(environment.sessionTimeoutInterval).subscribe(() => {
      if (this.isSessionCheckActive) {
        this.silentAuthentication();
      }
    });
  }



  public cancelPendingRequests() {
    this.pendingHTTPRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.pendingHTTPRequests$.asObservable();
  }

  //Logout method removing the email, passowrd, token, keepsignin and state
  public logout(persistState: boolean = false) {
    console.log(window.location.origin);
    const user = this.storageService.getItem('signinUser');
    localStorage.clear();
    this.storageService.setItem('email', user?.email);
    this.dilogService.showDialog({
      type: BdpDialogTypes.SESSION,
      visibility: false,
      width: '420px',
      header: '',
      body: ``,
      action: 'Continue',
      reject: 'Logout',
      onAccept: () => {
      },
      onReject: () => {
      }
    });
    if (persistState) {
      this.storageService.setItem("lastVisitedPage", window.location.href.split("#").pop());
    }
    this.auth.logout({ returnTo: window.location.origin }
    );
  }



}

function form(arg0: Promise<any>) {
  throw new Error("Function not implemented.");
}

export interface UserDetails {
  id: string,
  firstName?: string,
  lastName?: any,
  email?: string,
  role: string,
  userName: string,
}

export enum UserTypes {
  USER = 'user',
  MANAGER = 'manager',
  CUSTOMER = 'customer',
}


